import { Api } from "../Api";
import { ApiMetadata } from "./ApiMetadata";
import { ApiMetadataCache } from "./ApiMetadataCache";
import { Collection } from "../Collection";
import { StringUtil } from "../StringUtil";

export class ApiMetadataRetriever {
    private static readonly inFlightApiCalls: Collection<Promise<ApiMetadata>> = {};

    public static getFromCache(endpoint: string): ApiMetadata {
        if (StringUtil.isEmptyString(endpoint)) {
            return null;
        }
        const result = ApiMetadataCache.get(endpoint);
        if (result == null) {
            this.get(endpoint);
        }
        return result;
    }

    public static async get(endpoint: string): Promise<ApiMetadata> {
        if (StringUtil.isEmptyString(endpoint)) {
            return Promise.resolve(null);
        }
        if (this.inFlightApiCalls[endpoint] != null) {
            return this.inFlightApiCalls[endpoint].then(() => {
                return ApiMetadataCache.get(endpoint);
            });
        }
        const cached = ApiMetadataCache.get(endpoint);
        if (cached != null) {
            return Promise.resolve(cached);
        }
        const serviceName = StringUtil.stringBefore(endpoint, ":", false, null);
        const endpointSuffix = StringUtil.stringAfter(endpoint, ":", false, endpoint);
        const metadataName = serviceName == null ? "metadata" : serviceName + ":metadata";
        this.inFlightApiCalls[endpoint] = Api.search(metadataName, { endpoint: endpointSuffix }).then(response => {
            const result: ApiMetadata = new ApiMetadata();
            result.fillFromApiResponse(response);
            ApiMetadataCache.put(endpoint, result);
            delete this.inFlightApiCalls[endpoint];
            return result;
        });
        return this.inFlightApiCalls[endpoint];
    }
}
